// Base layer textures
uniform sampler2D panoramaCurrent;
uniform sampler2D panoramaNext;
uniform sampler2D motionFlow;
uniform sampler2D layerPanoramaSphereCurrent;
uniform sampler2D layerPanoramaSphereNext;

// Transition-related uniforms
uniform float u_transitionPercentage;
uniform float u_panoramaCurrentAlpha;
uniform float u_panoramaNextAlpha;
uniform bool u_isPanoramaTransition;

// Time and view settings
uniform vec2 u_rotation;
uniform float u_fovy;
uniform float u_aspectratio;


#define PI 3.14159265359

// Rotation function to rotate the ray direction
vec3 rotate(vec3 v) {
    float cosX = cos(u_rotation.x);
    float sinX = sin(u_rotation.x);
    float cosY = cos(u_rotation.y + PI / 2.0);
    float sinY = sin(u_rotation.y + PI / 2.0);

    vec3 rotated = vec3(v.x, cosX * v.y - sinX * v.z, sinX * v.y + cosX * v.z);
    rotated = vec3(cosY * rotated.x + sinY * rotated.z, rotated.y, -sinY * rotated.x + cosY * rotated.z);
    return rotated;
}

// Convert 3D polar coordinates to 2D UV coordinates
vec2 polarToUV(vec3 normalizedPos) {
    float lon = atan(normalizedPos.z, normalizedPos.x);
    float lat = asin(normalizedPos.y);
    return vec2(1.0 - lon / (2.0 * PI) + 0.5, lat / PI + 0.5);
}

// Get equirectangular texture coordinates based on field of view and aspect ratio
vec2 getEquirectangularTexCoord() {
    vec2 ndc = vec2((v_texCoord.x * 2.0 - 1.0) * u_aspectratio, v_texCoord.y * 2.0 - 1.0);
    float fov = tan(radians(u_fovy) / 2.0);

    vec3 rayDir = vec3(ndc.x * fov, ndc.y * fov, 1.0);
    rayDir = rotate(normalize(rayDir));
    return polarToUV(normalize(rayDir));
}
// Render the base panorama layer, handling transitions between layers
vec4 renderBaseLayer() {
    vec4 colorRaw = vec4(0.0);
    vec2 equirectangularTexCoord = getEquirectangularTexCoord();

    if (u_isPanoramaTransition) {
        // Blend the current and next panorama layers during transition
        colorRaw = mix(
            texture2D(layerPanoramaSphereCurrent, v_texCoord),
            texture2D(layerPanoramaSphereNext, v_texCoord),
            u_transitionPercentage
        );

        // Blend with true panorama textures for smooth transitions
        vec4 colorCurrent = texture2D(panoramaCurrent, equirectangularTexCoord);
        vec4 colorNext = texture2D(panoramaNext, equirectangularTexCoord);

        colorRaw = mix(colorRaw, colorCurrent, u_panoramaCurrentAlpha);
        colorRaw = mix(colorRaw, colorNext, u_panoramaNextAlpha);
    } else {
        // Render only the current panorama texture
        colorRaw = texture2D(panoramaCurrent, equirectangularTexCoord);
    }

    return colorRaw;
}

// Main function that renders the scene
void main() {
    vec4 colorRaw = renderBaseLayer();  // Render the base panorama layer
    colorRaw = renderLayers(colorRaw);  // Apply additional layers on top
    gl_FragColor = colorRaw;            // Output the final color
}
